/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForTagPosture extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForTagPosture");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForTagPosture.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForTagPosture>): BackgroundJobPayloadForTagPosture {
        let obj = Object.assign(new BackgroundJobPayloadForTagPosture(), model);
        BackgroundJobPayloadForTagPosture.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForTagPosture>): BackgroundJobPayloadForTagPosture {
        if (!model) return null;
        return BackgroundJobPayloadForTagPosture.newInstance(<BackgroundJobPayloadForTagPosture> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForTagPosture) {
        if (!obj) return;

        models.BackgroundJobPayloadForTagPosture.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForTagPosture): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForTagPosture.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.progress) {
            models.TagPostureSnapshotProgress.fixupPrototype(this.progress);
        }
    }

    snapshot_id: string;

    /**
     * Progress of the generation
     */
    progress: models.TagPostureSnapshotProgress;

}
